import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchSuggestions } from './actions'
import { Showcase } from '../../Showcase'
import { Products } from './reducer'
import { ProductCardContainer } from '../../Availability'

import ProductSuggestionPlaceholder from './ProductSuggestionPlaceholder'

import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'

class ProductSuggestionContainer extends Component {
  componentDidMount () {
    this.props.fetchSuggestions()
  }

  componentDidUpdate (prevProps) {
    if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
      this.props.fetchSuggestions()
    }
  }

  render () {
    const urlSearchPage = `/showcase/?identifier=${this.props.showcase.url}&type=${this.props.showcase.type}`
    const {
      products,
      onlyCash,
      title,
      titleOnlyCash,
      titleMobile,
      showcase
    } = this.props
    const isLoaded = products && products.length > 0

    return (
      <div
        className={`bx-showcase pos-relative ${showcase.id} ${showcase.url}_${showcase.type}`}
      >
        <ReactPlaceholder
          ready={isLoaded}
          customPlaceholder={<ProductSuggestionPlaceholder />}
        >
          <Showcase
            title={onlyCash ? titleOnlyCash : title}
            titleMobile={titleMobile}
            searchPage={urlSearchPage}
            isLoading={!isLoaded}
          >
            {products.map(p => (
              <Fragment>
                <ProductCardContainer {...p} key={p.sku} cardClass='col-12' />
              </Fragment>
            ))}
          </Showcase>
        </ReactPlaceholder>
      </div>
    )
  }
}

ProductSuggestionContainer.propTypes = {
  fetchSuggestions: PropTypes.func,
  title: PropTypes.string,
  titleOnlyCash: PropTypes.string,
  titleMobile: PropTypes.string,
  products: PropTypes.array,
  onlyCash: PropTypes.bool,
  showcase: PropTypes.object
}

const mapStateToProps = ({ productSuggestion, onlyCash }) => ({
  ...Products(productSuggestion),
  onlyCash
})

const mapDispatchToProps = dispatch => ({
  fetchSuggestions: () => dispatch(fetchSuggestions('home'))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductSuggestionContainer)



// WEBPACK FOOTER //
// ./src/features/Suggestion/ProductSuggestion/ProductSuggestionContainer.js